import { useState } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import { Switch, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";
import OmniMenuItem from "../ui/omniMenuItem";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import OmniTextField from "../ui/omniTextField";
import AlertDialog from "./alertDialog";

// ES Modules import

const BotpressUserFeedbackDialog = props => {
  const {
    open,
    userFeedbackRecord,
    onClose,
    onAccept,
    onDelete,
    dialogTitle = "Edit Feedback",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    maxWidth = "md",
    fullWidth = true,
    deleteMessage = "Delete",
  } = props;

  const theme = useTheme();

  const [editedUserFeedbackRecord] = useState(userFeedbackRecord);

  //input
  const [userFeedback, setUserFeedback] = useState(userFeedbackRecord.comment);
  const [userSentiment, setUserSentiment] = useState(userFeedbackRecord.value);
  const [userName, setUserName] = useState(userFeedbackRecord.userName);
  const [archived, setArchived] = useState(userFeedbackRecord.archived);
  const [status, setStatus] = useState(userFeedbackRecord.status);

  // const [inputTextValid, setUserFeedbackValid] = useState(false);
  // useEffect(() => {
  //   userFeedback ? setUserFeedbackValid(true) : setUserFeedbackValid(false);
  // }, [userFeedback]);

  const [showConfirm, setShowConfirm] = useState(false);

  const onDeleteHandler = () => {
    onDelete(editedUserFeedbackRecord);
  };

  const onAcceptHandler = () => {
    try {
      editedUserFeedbackRecord.comment = userFeedback;
      editedUserFeedbackRecord.value = userSentiment;
      editedUserFeedbackRecord.userName = userName;
      editedUserFeedbackRecord.status = status;
      editedUserFeedbackRecord.archived = archived;

      //TODO check to see other stuff needs updating
      onAccept(editedUserFeedbackRecord);
    } catch (error) {
      console.log(error);
    }
  };

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item size={{ xs: 6 }}>
            <OmniTextField
              sx={{ width: "100%" }}
              label={"Bot Message"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              rowCount={13}
              multiline={true}
              value={userFeedbackRecord.message}
              disabled={true}
            />
          </Grid>
          <Grid item container size={{ xs: 6 }}>
            <Grid item container size={{ xs: 12 }}>
              <Grid item container size={{ xs: 5 }}>
                <OmniTextField
                  label="Sentiment"
                  type="textInput"
                  select
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"organizationType"}
                  value={userSentiment}
                  onChange={event => {
                    setUserSentiment(event.target.value);
                  }}
                >
                  <OmniMenuItem key={"negative"} value={"negative"}>
                    {"Negative"}
                  </OmniMenuItem>
                  <OmniMenuItem key={"positive"} value={"positive"}>
                    {"Positive"}
                  </OmniMenuItem>
                </OmniTextField>
              </Grid>
              <Grid item container size={{ xs: 7 }}>
                <OmniTextField
                  label="Feedback Status"
                  type="textInput"
                  select
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"organizationType"}
                  value={status}
                  onChange={event => {
                    setStatus(event.target.value);
                  }}
                >
                  {constants.feedbackStatus.map(orgType => (
                    <OmniMenuItem key={orgType.value} value={orgType.value}>
                      {orgType.label}
                    </OmniMenuItem>
                  ))}
                </OmniTextField>
              </Grid>
              <Grid item container size={{ xs: 12 }}>
                <OmniTextField
                  sx={{ width: "100%" }}
                  label={"User Feedback"}
                  type="textInput"
                  variant="outlined"
                  name={uuid()} //prevents AutoComplete Suggestions
                  id={"message"}
                  rowCount={8}
                  multiline={true}
                  value={userFeedback}
                  onChange={event => setUserFeedback(event.target.value)}
                />
              </Grid>

              <Grid item container size={{ xs: 8 }}>
                <OmniTextField
                  sx={{ width: "100%", marginTop: "2px" }}
                  label={"Feedback Given By"}
                  type="textInput"
                  variant="outlined"
                  name={uuid()} //prevents AutoComplete Suggestions
                  id={"message"}
                  rowCount={7}
                  multiline={false}
                  value={userName}
                  onChange={event => setUserName(event.target.value)}
                />
              </Grid>

              <Grid item container size={{ xs: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    marginTop: "4px",
                    marginBottom: "8px",
                    justifyContent: "Right",
                  }}
                >
                  <Switch
                    checked={archived}
                    onChange={() => {
                      setArchived(val => !val);
                    }}
                  />
                  <Typography variant="body2" sx={{ marginTop: "8px" }}>
                    Archived
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            paddingRight: theme.spacing(2),
            paddingBottom: 0,
            display: "flex",
            flexDirection: "row",
            userSelect: "none",
            webkitUserSelect: "none",
            position: "relative",
            flexGrow: 1,
          }}
        >
          {userFeedbackRecord.id != null && props.onDelete != null && (
            <OmniResponsiveButton
              icon={<DeleteIcon />}
              onClick={() => setShowConfirm(true)}
              buttonText={deleteMessage}
              tooltipTitle=""
            />
          )}
        </Box>
        <Box
          sx={{
            flexGrow: 0,
            flexShrink: 1,
          }}
        >
          {cancelMessage && (
            <Button
              onClick={onCloseHandler}
              color="secondary"
              variant="contained"
              sx={{ marginRight: theme.spacing(2) }}
            >
              {cancelMessage}
            </Button>
          )}
          <Button
            onClick={onAcceptHandler}
            color="secondary"
            variant="contained"
            disabled={userFeedback == null || userFeedback.length === 0}
          >
            {okMessage}
          </Button>
        </Box>
      </DialogActions>

      {showConfirm && (
        <AlertDialog
          open={showConfirm}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want delete this Entry?"}
          onAccept={() => {
            setShowConfirm(false);
            onDeleteHandler();
          }}
          onClose={() => {
            setShowConfirm(false);
          }}
        />
      )}
    </Dialog>
  );
};

export default BotpressUserFeedbackDialog;
